export default __webpack_public_path__ + "static/media/placeholder_business05-es-mobile.3400f102.png";